import * as React from "react"

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'destructive' | 'outline' | 'secondary' | 'ghost' | 'link'
  size?: 'default' | 'sm' | 'lg' | 'icon'
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className = '', variant = 'default', size = 'default', ...props }, ref) => {
    // Base styles
    let classes = 'inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50'

    // Variant styles
    if (variant === 'default') {
      classes += ' bg-primary text-white hover:bg-primary-dark'
    } else if (variant === 'destructive') {
      classes += ' bg-destructive text-destructive-foreground hover:bg-destructive/90'
    } else if (variant === 'outline') {
      classes += ' border border-input bg-background hover:bg-accent hover:text-accent-foreground'
    } else if (variant === 'secondary') {
      classes += ' bg-secondary text-white hover:bg-secondary-dark'
    } else if (variant === 'ghost') {
      classes += ' hover:bg-accent hover:text-accent-foreground'
    } else if (variant === 'link') {
      classes += ' text-primary underline-offset-4 hover:underline'
    }

    // Size styles
    if (size === 'default') {
      classes += ' h-10 px-4 py-2'
    } else if (size === 'sm') {
      classes += ' h-9 rounded-md px-3'
    } else if (size === 'lg') {
      classes += ' h-11 rounded-md px-8'
    } else if (size === 'icon') {
      classes += ' h-10 w-10'
    }

    // Add custom className
    if (className) {
      classes += ' ' + className
    }

    return (
      <button
        className={classes}
        ref={ref}
        {...props}
      />
    )
  }
)
Button.displayName = "Button"

export { Button }
